import { CommonDataSetAction, ItemAttrListDataSet } from '@mri/types';

export function cardGetSetDisable(prop: ItemAttrListDataSet, actions: CommonDataSetAction): unknown {
  if (!actions.disableWhen) return false;

  return actions.disableWhen(prop);
}
